import { useState, useEffect } from 'react';

export function scrollIntoView(sectionId: string) {
    const section = document.getElementById(sectionId.startsWith('#')
        ? sectionId.substring(1)
        : sectionId);

    if (section) {
        section.scrollIntoView({
            behavior: 'smooth',
        });
    }
}

export function scrollTo(sectionId: string, offset?: number) {
    const section = document.getElementById(sectionId.startsWith('#')
        ? sectionId.substring(1)
        : sectionId);

    if (section) {
        window.scrollTo({
            behavior: 'smooth',
            top: section.offsetTop - (offset || 0)
        });
    }
}

export function usePreventScroll(prevent: boolean, callBack: Function, params?: Array<any>) {
    const keys = {
        37: 1,
        38: 1,
        39: 1,
        40: 1
    };
    const [passive, setPassive] = useState(false);
    let timer = Math.round(new Date().getTime() / 1000)

    function preventDefault(e: any) {
        const now = Math.round(new Date().getTime() / 1000);

        if (prevent) {
            if (timer !== now) {
                timer = now;
                callBack(e.wheelDeltaY > 0 ? 'up' : 'down');
            }
            e.preventDefault();
        }
    }

    function preventDefaultForScrollKeys(e: any) {
        //@ts-ignore
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: () => setPassive(true)
        }));
    } catch (e) { }

    const wheelOpt = passive ? { passive: false } : false;
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    const win = (window as any);

    useEffect(() => {
        if (prevent) {
            win.addEventListener('DOMMouseScroll', preventDefault, false);
            win.addEventListener(wheelEvent, preventDefault, wheelOpt);
            win.addEventListener('touchmove', preventDefault, wheelOpt);
            win.addEventListener('keydown', preventDefaultForScrollKeys, false);

            return () => {
                win.removeEventListener('DOMMouseScroll', preventDefault, false);
                win.removeEventListener(wheelEvent, preventDefault, wheelOpt);
                win.removeEventListener('touchmove', preventDefault, wheelOpt);
                win.removeEventListener('keydown', preventDefaultForScrollKeys, false);
            };
        }
    }, params);
}